// extracted by mini-css-extract-plugin
export default {"container":"label_container__J3Nrx","green":"label_green__TAK9E","red":"label_red__XDOhR"};